import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import {getParams} from "../utils/get-params";
import "bootstrap-daterangepicker";

@Options({
    template: false,
    ui: {
        dateFilter:     "[data-js-ui=date-filter]",
        dateClearBtn:   "[data-js-ui=date-clear-btn]",
        selectFilter:   "[data-js-ui~=select-filter]",
        venueFilter:    "[data-js-ui~=venue-filter]",
        filterForm:     "[data-js-ui=filter-form]",
        toggleCalendar: "[data-js-ui=calendar-toggle]"
    }
})
export default class CalendarFilterView extends Marionette.View<Backbone.Model>{

    _dateFilterOptions = {
        autoUpdateInput: false,
        opens: "left",
        buttonClasses: "btn btn-medium",
        applyClass: "btn-solid",
        cancelClass: "btn-hollow",
    }
    _dateFilterParent = ".filter-date-select";
    _dateFormat = 'MMM DD, YYYY';

    onRender() {
        this.initDateFilter();
        this.initVenueFilter();
        this.getUrlParameters();
        this.checkDateFilter();
    }

    initDateFilter() {
        this.ui.dateFilter.daterangepicker(this._dateFilterOptions);
        this.ui.dateFilter.on(
            'apply.daterangepicker', this.onApplyDateFilter.bind(this));
        this.ui.dateFilter.on(
            'cancel.daterangepicker', this.onCancelDateFilter.bind(this));
    }

    initVenueFilter() {

    }

    onApplyDateFilter(event:any, dateFilter:any) {
        const startDate = $.trim(dateFilter.startDate.format(this._dateFormat));
        const endDate = $.trim(dateFilter.endDate.format(this._dateFormat));
        const dateRange = `${startDate}-${endDate}`;

        this.updateDateFilter(dateRange);
        this.wantsSubmitForm();
    }

    onCancelDateFilter() {
        this.updateDateFilter('');
    }

    updateDateFilter(value:string) {
        this.ui.dateFilter.val(value).trigger('change');
    }

    getDateFilterValue() {
        return this.ui.dateFilter.val();
    }

    getUrlParameters() {
        const url = window.location.href;
        const querystring = url.split('?')[1];

        if (querystring) {
            const params = getParams(querystring);
            if (params.daterange && params.daterange.length) {
                this.updateDateFilter(params.daterange);
            }
        }
    }

    checkDateFilter() {
        if (this.getDateFilterValue()) {
            this.appendClearButton();
        }
    }

    appendClearButton() {
        this.ui.dateFilter
            .parent(this._dateFilterParent)
            .append(this.getClearButtonHtml());
    }

    getClearButtonHtml() {
        return "<span class='filter__date-clear-btn' data-js-ui='date-clear-btn'>×</span>";
    }
    
    @on("click @ui.toggleCalendar")
    toggleCalendarVisibility(element) {
        console.log('clicked');
        console.log(element);
    }

    @on("click @ui.dateClearBtn")
    onDateClearBtnClick(e) {
        this.onCancelDateFilter();
        this.wantsSubmitForm();
    }

    @on("change @ui.selectFilter")
    onSelectFilterChange(e) {
        const $target = $(e.currentTarget);
        const isVenueFilter = $target.is(this.ui.venueFilter);

        if (isVenueFilter && !$target.val()) {
            $target.val('all').trigger('change');
        };

        this.wantsSubmitForm();
    }

    wantsSubmitForm() {
        this.ui.filterForm.submit();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/calendar-filter-view.ts